import { render, staticRenderFns } from "./PhotoReports.vue?vue&type=template&id=353ab4aa&lang=pug"
import script from "./PhotoReports.vue?vue&type=script&lang=js"
export * from "./PhotoReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports